import _defineProperty from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import Vue from 'vue';
import QBtn from "../btn/QBtn.js";
import QBtnGroup from "../btn-group/QBtnGroup.js";
import ListenersMixin from "../../mixins/listeners.js";
import FormMixin from "../../mixins/form.js";
import RippleMixin from "../../mixins/ripple.js";
import { slot, mergeSlot } from "../../utils/slot.js";
export default Vue.extend({
  name: 'QBtnToggle',
  mixins: [ListenersMixin, RippleMixin, FormMixin],
  props: {
    value: {
      required: true
    },
    options: {
      type: Array,
      required: true,
      validator: function validator(v) {
        return v.every(function (opt) {
          return ('label' in opt || 'icon' in opt || 'slot' in opt) && 'value' in opt;
        });
      }
    },
    // To avoid seeing the active raise shadow through the transparent button, give it a color (even white).
    color: String,
    textColor: String,
    toggleColor: {
      type: String,
      default: 'primary'
    },
    toggleTextColor: String,
    outline: Boolean,
    flat: Boolean,
    unelevated: Boolean,
    rounded: Boolean,
    push: Boolean,
    glossy: Boolean,
    size: String,
    padding: String,
    noCaps: Boolean,
    noWrap: Boolean,
    dense: Boolean,
    readonly: Boolean,
    disable: Boolean,
    stack: Boolean,
    stretch: Boolean,
    spread: Boolean,
    clearable: Boolean
  },
  computed: {
    hasActiveValue: function hasActiveValue() {
      var _this = this;

      return this.options.find(function (opt) {
        return opt.value === _this.value;
      }) !== void 0;
    },
    formAttrs: function formAttrs() {
      return {
        type: 'hidden',
        name: this.name,
        value: this.value
      };
    },
    btnOptions: function btnOptions() {
      var _this2 = this;

      var mergeOption = function mergeOption(opt, key) {
        return opt[key] === void 0 ? _this2[key] : opt[key];
      };

      return this.options.map(function (opt, i) {
        return {
          slot: opt.slot,
          options: {
            key: i,
            class: opt.class,
            style: opt.style,
            on: _objectSpread(_objectSpread({}, _this2.qListeners), {}, {
              click: function click(e) {
                return _this2.__set(opt.value, opt, e);
              }
            }),
            attrs: _objectSpread({
              'aria-pressed': opt.value === _this2.value ? 'true' : 'false'
            }, opt.attrs),
            props: _objectSpread(_objectSpread({}, opt), {}, {
              slot: void 0,
              class: void 0,
              style: void 0,
              value: void 0,
              attrs: void 0,
              outline: _this2.outline,
              flat: _this2.flat,
              rounded: _this2.rounded,
              push: _this2.push,
              unelevated: _this2.unelevated,
              dense: _this2.dense,
              disable: _this2.disable === true || opt.disable === true,
              // Options that come from the button specific options first, then from general props
              color: opt.value === _this2.value ? mergeOption(opt, 'toggleColor') : mergeOption(opt, 'color'),
              textColor: opt.value === _this2.value ? mergeOption(opt, 'toggleTextColor') : mergeOption(opt, 'textColor'),
              noCaps: mergeOption(opt, 'noCaps') === true,
              noWrap: mergeOption(opt, 'noWrap') === true,
              size: mergeOption(opt, 'size'),
              padding: mergeOption(opt, 'padding'),
              ripple: mergeOption(opt, 'ripple'),
              stack: mergeOption(opt, 'stack') === true,
              stretch: mergeOption(opt, 'stretch') === true
            })
          }
        };
      });
    }
  },
  methods: {
    __set: function __set(value, opt, e) {
      if (this.readonly !== true) {
        if (this.value === value) {
          if (this.clearable === true) {
            this.$emit('input', null, null);
            this.$emit('clear');
          }
        } else {
          this.$emit('input', value, opt);
        }

        this.$emit('click', e);
      }
    }
  },
  render: function render(h) {
    var _this3 = this;

    var child = this.btnOptions.map(function (opt) {
      return h(QBtn, _objectSpread({}, opt.options), opt.slot !== void 0 ? slot(_this3, opt.slot) : void 0);
    });

    if (this.name !== void 0 && this.disable !== true && this.hasActiveValue === true) {
      this.__injectFormInput(child, 'push');
    }

    return h(QBtnGroup, {
      staticClass: 'q-btn-toggle',
      props: {
        outline: this.outline,
        flat: this.flat,
        rounded: this.rounded,
        push: this.push,
        stretch: this.stretch,
        unelevated: this.unelevated,
        glossy: this.glossy,
        spread: this.spread
      }
    }, mergeSlot(child, this, 'default'));
  }
});